import { useFormikContext } from 'formik'
import { FC } from 'react'

import { getCurrencySymbol } from '@utils/transaction.utils'

import { CurrencyType } from '@model/WalletDto'

import { createFormCurrencyAmountField } from '@global/formField/CurrencyAmountRateField'

import type { WithdrawalFormValues } from '../WithdrawalFlowLayout/types'

const FormCurrencyAmountField = createFormCurrencyAmountField()

export const MAX_WITHDRAWAL_AMOUNT = 10_000_000

export const WithdrawalAmountField: FC<{ onBlur?: () => void }> = ({ onBlur }) => {
  const { values } = useFormikContext<WithdrawalFormValues>()

  const providerCurrencyId = values.paymentProvider?.currency?.id || ''
  const walletCurrencyId = values.wallet?.currency?.id || ''

  const symbol = getCurrencySymbol((providerCurrencyId || walletCurrencyId) as CurrencyType)

  return (
    <FormCurrencyAmountField
      name='amount'
      label={undefined}
      placeholder={undefined}
      fromCurrency={providerCurrencyId}
      toCurrency={walletCurrencyId}
      leftText={symbol}
      max={MAX_WITHDRAWAL_AMOUNT}
      fullWidth
      required
      onBlur={onBlur}
    />
  )
}
